import React from 'react';

import { Tag } from '@chakra-ui/react';

const SiengeBadge: React.FC = () => {
  return (
    <Tag
      variant="solid"
      width="auto"
      minWidth="fit-content"
      fontSize="xs"
      fontWeight="bold"
      colorScheme="siengeRed"
      paddingX={1.5}
      paddingY={0.5}
      borderRadius="base"
      whiteSpace="nowrap"
      title="Base integrada com o Sienge Plataforma"
      userSelect="none"
      cursor="default"
      lineHeight="shorter"
      flexShrink={0}
    >
      Sienge
    </Tag>
  );
};

export default SiengeBadge;
